import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n\n    & > i:first-of-type {\n        font-size: 3rem;\n        margin-left: 16px;\n        margin-right: 32px;\n        color: white;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledOpenFlatCard = styled.div(_templateObject(), function (props) {
  return "\n        position: relative;\n        max-width: 100%;\n        box-sizing: border-box;\n        padding: ".concat(props.theme.components.card.padding, ";\n        width: ").concat(props.width, ";\n        background: ").concat(props.color ? props.color : props.theme.components.card.lightBackground, ";\n        box-shadow: ").concat(props.theme.components.card.shadow, ";\n        border-radius: 4px;\n\n        ").concat(props.asideColor ? "\n                    border: 5px solid ".concat(props.asideColor, ";\n                    border-right: 0;\n                    border-top: 0;\n                    border-bottom: 0;\n                ") : '', "\n    ");
});
export var StyledCardContent = styled.div(_templateObject2());